import axios from '@/plugins/axios';

export function findFlowChartListByUserId(params) {
  return axios.get('/flowChart/findFlowChartListByUserId', {
    params: params
  });
}
export function saveFlowChart(params) {
  return axios.post('/flowChart/saveFlowChart', params);
}
export function editFlowChart(params) {
  return axios.post('/flowChart/editFlowChart', params);
}
export function removeFlowChart(params) {
  return axios.post('/flowChart/removeFlowChart', {
    flowId: params.flowId,
    updateId: params.updateId
  });
}
export function findFlowChartById(flowId) {
  return axios.get('/flowChart/findFlowChartById', {
    params: {
      flowId: flowId
    }
  });
}
export function findFlowChartByType(params) {
  return axios.get('/flowChart/findFlowChartByType', {
    params: params
  });
}
/**
 * 0:""
 * 1:采购商询价流程
 * 2:采购商招标流程
 * 3:供应商询价流程
 * 4:供应商招标流程
 *
 */
// 根据角色获取不同的流程应用名称
export function getFlowChartTemNameByRoleId(roleId, userRoles) {
  let id = '' + roleId;
  let arr = [];
  let flowName = {
    default: {
      value: 0,
      label: '请选择流程'
    },
    buyProProj: {
      value: 1,
      label: '采购商询价流程'
    },
    buyBidProj: {
      value: 2,
      label: '采购商招标流程'
    },
    supProProj: {
      value: 3,
      label: '供应商询价流程'
    },
    supBidProj: {
      value: 4,
      label: '供应商招标流程'
    }
  };
  arr.push(flowName.default);
  flowChartNameArr(arr, id, flowName, userRoles);
  return arr;
}

function flowChartNamePushArrKey(keyArr, id) {
  if (id === '6' || id === '7') {
    keyArr.push('buyProProj');
    keyArr.push('buyBidProj');
  }
  if (id === '8' || id === '9') {
    keyArr.push('supProProj');
    keyArr.push('supBidProj');
  }
  if (id === '1') {
    keyArr.push('buyProProj');
    keyArr.push('buyBidProj');
    keyArr.push('supProProj');
    keyArr.push('supBidProj');
  }
}

function flowChartNameArr(arr, id, flowName, userRoles) {
  var keyArr = [];
  if (!userRoles) {
    flowChartNamePushArrKey(keyArr, id);
  } else {
    userRoles.forEach((element) => {
      let code = '' + element.roleCode;
      flowChartNamePushArrKey(keyArr, code);
    });
  }
  keyArr = [...new Set(keyArr)];
  keyArr.forEach((element) => {
    arr.push(flowName[element]);
  });
}

// 根据角色获取不同的流程左侧流程图
export function getFlowChartSidebar(roleId, userRoles) {
  let id = '' + roleId;
  let arr = [];
  let flowChartSide = {
    buyProProj: {
      id: 'general',
      title: '采购商询价',
      data: [{
        value: '草稿',
        status: '1',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '待发布',
        status: '2',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '发布中',
        status: '3',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已撤回',
        status: '4',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已中止',
        status: '5',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已选定',
        status: '7',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已截止',
        status: '11',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {

        value: '',
        status: null,
        width: '50',
        height: '50',
        xmlType: 2
      }
      ]
    },
    buyBidProj: {
      id: 'general',
      title: '采购商招标',
      data: [{
        value: '草稿',
        status: '1',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '待发布',
        status: '2',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '发布中',
        status: '3',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已撤回',
        status: '4',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已中止',
        status: '5',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '待选定',
        status: '6',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已选定',
        status: '7',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '开标中',
        status: '9',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已截止',
        status: '11',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '公示中',
        status: '12',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {

        value: '',
        status: null,
        width: '50',
        height: '50',
        xmlType: 2
      }
      ]
    },
    supProProj: {
      id: 'general',
      title: '供应商询价',
      data: [{
        value: '草稿',
        status: '1',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已撤回',
        status: '3',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已失效',
        status: '4',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已中选',
        status: '6',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已结束',
        status: '7',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已报价',
        status: '9',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {

        value: '',
        status: null,
        width: '50',
        height: '50',
        xmlType: 2
      }
      ]
    },
    supBidProj: {
      id: 'general',
      title: '供应商招标',
      data: [{
        value: '草稿',
        status: '1',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已撤回',
        status: '3',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已失效',
        status: '4',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已中选',
        status: '6',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已结束',
        status: '7',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已报价',
        status: '9',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '已开标',
        status: '10',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {
        value: '公示中',
        status: '12',
        width: '120',
        height: '60',
        xmlType: 1
      },
      {

        value: '',
        status: null,
        width: '50',
        height: '50',
        xmlType: 2
      }
      ]
    }
  };
  flowChartNameArr(arr, id, flowChartSide, userRoles);
  return changeFlowChartSidebarArr(arr);
}

function changeFlowChartSidebarArr(arr) {
  let sideArr = [];
  arr.forEach((ele, index) => {
    let json = {
      id: ele.id,
      title: ele.title,
      data: []
    };
    ele.data.forEach((el, ind) => {
      let json1 = {
        value: el.value,
        height: el.height,
        width: el.width,
        status: el.status
      };
      if (el.xmlType === 1) {
        json1.xml = `
        <mxGraphModel dx="0" dy="0" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" background="#ffffff">
           <root>
               <mxCell id="0"/>
               <mxCell id="1" parent="0"/>
               <mxCell id="2" value="${el.value}" style="rounded=1;whiteSpace=wrap;html=1;fillColor=#dddddd;strokeColor=#dddddd;strokeWidth=2;gradientColor=#ffffff;shadow=1;gradientDirection=north;fontColor=#333333;" parent="1" status="${el.status}" vertex="1">
                   <mxGeometry x="0" y="0" width="${el.width}" height="${el.height}" as="geometry"/>
               </mxCell>
           </root>
         </mxGraphModel>
        `;
      }
      if (el.xmlType === 2) {
        json1.xml = `
        <mxGraphModel dx="0" dy="0" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" background="#ffffff">
          <root>
            <mxCell id="0"/>
            <mxCell id="1" parent="0"/>
            <mxCell id="2" value="${el.value}" style="endArrow=classic;html=1;strokeColor=#b3b3b3;strokeWidth=3;" edge="1" status="${el.status}" parent="1">
              <mxGeometry width="${el.width}" height="${el.height}" relative="1" as="geometry">
                <mxPoint x="50" y="50" as="sourcePoint"/>
                <mxPoint x="0" y="0" as="targetPoint"/>
              </mxGeometry>
            </mxCell>
          </root>
        </mxGraphModel>
        `;
      }

      json.data.push(json1);
    });
    sideArr.push(json);
  });
  return sideArr;
}
export function getEditStyleOptions() {
  return [{
    label: '圆形',
    value: 'ellipse;shape=doubleEllipse;whiteSpace=wrap;html=1;aspect=fixed;fillColor=#dddddd;strokeColor=#dddddd;strokeWidth=2;gradientColor=#ffffff;shadow=1;gradientDirection=north;fontColor=#333333;'
  },
  {
    label: '长方形',
    value: 'rounded=1;whiteSpace=wrap;html=1;fillColor=#dddddd;strokeColor=#dddddd;strokeWidth=2;gradientColor=#ffffff;shadow=1;gradientDirection=north;fontColor=#333333;'
  },
  {
    label: '平行四边形',
    value: 'shape=parallelogram;whiteSpace=wrap;html=1;fillColor=#dddddd;strokeColor=#dddddd;strokeWidth=2;gradientColor=#ffffff;shadow=1;gradientDirection=north;fontColor=#333333;'
  },
  {
    label: '六边形',
    value: 'shape=hexagon;perimeter=hexagonPerimeter;whiteSpace=wrap;html=1;fillColor=#dddddd;strokeColor=#dddddd;strokeWidth=2;gradientColor=#ffffff;shadow=1;gradientDirection=north;fontColor=#333333;'
  }
  ];
}
